import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getAllCountries = createAsyncThunk('Country/getAllCountries', async () => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.Country.GetAllCountries}`,
  });
});
